import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { SettingsProvider } from "@/context/SettingsContext";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Sidebar } from "@/components/Sidebar";
import { WhatsAppButton } from "@/components/WhatsAppButton";
import Dashboard from "@/pages/Dashboard";
import Pipeline from "@/pages/Pipeline";
import Enquiries from "@/pages/Enquiries";
import Followups from "@/pages/Followups";
import Clients from "@/pages/Clients";
import Settings from "@/pages/Settings";
import PublicEnquiry from "@/pages/PublicEnquiry";
import Login from "@/pages/Login";

function Shell() {
  return (
    <div className="min-h-screen bg-background">
      <Sidebar />
      <main className="px-4 pb-10 pt-[4.5rem] sm:px-8 lg:ml-64 lg:pt-8">
        <div className="mx-auto max-w-7xl">
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/pipeline" element={<Pipeline />} />
            <Route path="/enquiries" element={<Enquiries />} />
            <Route path="/today" element={<Followups />} />
            <Route path="/clients" element={<Clients />} />
            <Route path="/settings" element={<Settings />} />
          </Routes>
        </div>
      </main>
    </div>
  );
}

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="grid min-h-screen place-items-center bg-background text-sm text-slate-400">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <SettingsProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/enquire" element={<PublicEnquiry />} />
              <Route path="/login" element={<Login />} />
              <Route path="/*" element={<ProtectedRoute><Shell /></ProtectedRoute>} />
            </Routes>
            <WhatsAppButton />
          </BrowserRouter>
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </SettingsProvider>
    </div>
  );
}

export default App;
